import React from 'react';
import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'netlify-cms-ui-default';
import { jsx as ___EmotionJSX } from "@emotion/core";

function RelationPreview({
  value
}) {
  return ___EmotionJSX(WidgetPreviewContainer, null, value);
}

RelationPreview.propTypes = {
  value: PropTypes.node
};
export default RelationPreview;